import { Outlet, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import { LayoutDashboard, FileText, LogOut, Building2 } from "lucide-react";

export default function OwnerShell() {
  const { user, logout } = useAuth();
  const nav = useNavigate();

  const nav_items = [
    { to: "/owner/dashboard", label: "Portfolio", icon: LayoutDashboard, testid: "owner-nav-dashboard" },
    { to: "/owner/statements", label: "Statements", icon: FileText, testid: "owner-nav-statements" },
  ];

  const handleLogout = async () => {
    await logout();
    nav("/login");
  };

  return (
    <div className="min-h-screen flex bg-background text-foreground">
      <aside className="w-60 border-r border-white/10 bg-card px-3 py-6 flex-col hidden lg:flex" data-testid="owner-shell">
        <div className="px-2 mb-6 flex items-center gap-2">
          <img src="/prestigious-logo.png" alt="Prestigious Property Management Services" className="h-10 w-10" />
          <div>
            <div className="text-[10px] uppercase tracking-widest text-muted-foreground">Owner Portal</div>
          </div>
        </div>
        <nav className="flex-1 space-y-1">
          {nav_items.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              data-testid={item.testid}
              className={({ isActive }) =>
                `flex items-center gap-2 px-3 py-2 rounded text-sm transition ${isActive ? "bg-white/5 text-foreground" : "text-muted-foreground hover:text-foreground hover:bg-white/5"}`
              }
            >
              <item.icon size={14} /> {item.label}
            </NavLink>
          ))}
        </nav>
        <div className="mt-auto pt-4 border-t border-white/10 space-y-2">
          <div className="text-xs text-muted-foreground px-2">{user?.name || user?.email}</div>
          <Button variant="ghost" size="sm" onClick={handleLogout} className="w-full justify-start gap-2" data-testid="owner-logout">
            <LogOut size={14} /> Log out
          </Button>
        </div>
      </aside>
      <main className="flex-1 min-w-0 p-4 sm:p-6 lg:p-8 overflow-x-hidden">
        <Outlet />
      </main>
    </div>
  );
}
